export default "__VITE_ASSET__CJOT4Oc$__"